<script setup lang="ts">
import AvatarCross from '@/assets/icons/Avatars/AvatarCross.vue';
import { type MessageSchema } from '@/i18n';
import { useUserStore } from '@/stores/useUserStore';
import Button from 'primevue/button';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });
const router = useRouter();
const userStore = useUserStore();
const isRefreshing = ref(false);

onMounted(async () => {
  // Refresh user data in case of any changes
  console.log('[SubscriptionCancel] Refreshing user data after cancelled payment');
  isRefreshing.value = true;
  try {
    await userStore.refreshUser();
    console.log('[SubscriptionCancel] User data refreshed successfully');
  } catch (error) {
    console.error('[SubscriptionCancel] Failed to refresh user data:', error);
  } finally {
    isRefreshing.value = false;
  }
});

function goHome() {
  router.push({ path: '/' });
}

function goToSubscriptions() {
  router.push({ path: '/profile/subscriptions' });
}
</script>

<template>
  <main class="flex flex-col items-center justify-center p-4">
    <div class="mx-auto mb-8 mt-8 flex max-w-lg flex-col items-center justify-center gap-4">
      <!-- Success Icon -->
      <div class="w-24">
        <AvatarCross />
      </div>

      <!-- Success Message -->
      <h1 class="mb-4 text-center font-bold text-3xl text-gray-800">
        {{ t('common.error') }}
      </h1>

      <p class="mb-6 text-center">
        {{ t('subscription.errorSubscription') }}
      </p>

      <!-- Loading indicator while refreshing -->
      <div v-if="isRefreshing" class="flex items-center gap-2 text-gray-600">
        <i class="pi pi-spin pi-spinner"></i>
        <span>{{ t('common.loading') }}...</span>
      </div>

      <!-- Navigation Buttons -->
      <div class="flex flex-row flex-wrap items-center justify-center gap-4">
        <Button :label="t('subscription.currentPlan')" icon="pi pi-eye" outlined :disabled="isRefreshing" @click="goToSubscriptions"></Button>
        <Button :label="t('navBar.home')" icon="pi pi-home" :disabled="isRefreshing" @click="goHome"></Button>
      </div>
    </div>
  </main>
</template>
